<template>
  <div class="facture-data row">
    <div class="col m12 s12 data-column">
      <span class="title head">TYTUŁ FAKTURY/RACHUNKU (NR TRANSZY):</span>
      {{ token }}
    </div>
    <div class="col m12 s12 data-column">
      <div class="col m12 s12 company-info">
        <span class="title head">DANE PUNKTA:</span>
      </div>
      <div class="col m6 s12 company-info address">
        <span class="bold">Punkta sp. z o.o.</span> <br/>
        ul. Aleje Jerozolimskie 146D <br/>
        02-305 Warszawa
      </div>
      <div class="col m6 s12 company-info">
        <span class="title left">nr KRS:</span> 0000488906 <br/>
        <span class="title left">Regon:</span> 147010378 <br/>
        <span class="title left">NIP:</span> 522-30-11-279
      </div>
    </div>
    <div class="col m12 s12 data-column">
      <span class="title head">E-MAIL DO PRZESŁANIA FAKTUR/RACHUNKU:</span>
      <a :href="`mailto:faktury@punkta.pl?subject=Transza nr: ${token}`">
        faktury@punkta.pl
      </a>
    </div>
  </div>
</template>

<script>
  export default { props: [ 'token' ] }
</script>

<style lang="scss">
  @import 'src/stylesheets/variables';

  .facture-data {
    text-align: left;
    line-height: 21pt;
    font-size: 12pt;
    font-weight: 500;

    .data-column {
      margin-bottom: 15px;

      .company-info {
        padding: 0;
      }

      @media #{$small-and-down} {
        .address {
          margin-bottom: 13px;
        }
      }
    }

    .title {
      color: $not-important-text-color;
      font-weight: 600;
      font-size: 8pt;
    }

    .head {
      line-height: 17pt;
      display: block;
      margin-bottom: -5px;

      @media #{$small-and-down} {
        text-align: center;
      }
    }

    .left {
      min-width: 55px;
      font-size: 9pt;
    }
  }
</style>



// WEBPACK FOOTER //
// invoiceDetails.vue?59def068